import { render, staticRenderFns } from "./SubTree.vue?vue&type=template&id=5273c8a8&"
import script from "./SubTree.vue?vue&type=script&lang=js&"
export * from "./SubTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports